module.exports = __webpack_public_path__ + "static/media/step1.7f3a03f5.png";